/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ENUM_CONSULTATION_STATUS {
  DONE = "DONE",
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  NEW = "NEW",
}

export enum ENUM_PARTNER_STATUS {
  DONE = "DONE",
  ERROR = "ERROR",
  IN_PROGRESS = "IN_PROGRESS",
  NEW = "NEW",
}

export enum ENUM_REFUNDREQUEST_ORDERSTATUS {
  DONE = "DONE",
  ERROR = "ERROR",
  NEW = "NEW",
  WAITING = "WAITING",
}

export enum ENUM_REFUNDREQUEST_SIGNSENDSTATUS {
  CREATED_1 = "CREATED_1",
  DO_NOT_NEED_4 = "DO_NOT_NEED_4",
  ERROR_3 = "ERROR_3",
  SENDED_2 = "SENDED_2",
}

export enum ENUM_REFUNDREQUEST_SIGNSTATUS {
  CREATED_1 = "CREATED_1",
  DONE_4 = "DONE_4",
  DO_NOT_NEED_6 = "DO_NOT_NEED_6",
  ERROR_5 = "ERROR_5",
  IN_PROGRESS_3 = "IN_PROGRESS_3",
  SIGNED_2 = "SIGNED_2",
}

export enum ENUM_REFUNDREQUEST_STATUS {
  GEN_ERROR_7 = "GEN_ERROR_7",
  IN_GEN_QUEUE_1 = "IN_GEN_QUEUE_1",
  READY_TO_SEND_2 = "READY_TO_SEND_2",
  RECEIVE_SIGN_4 = "RECEIVE_SIGN_4",
  REFUND_DONE_5 = "REFUND_DONE_5",
  REJECT_6 = "REJECT_6",
  SENDED_TO_CLIENT_3 = "SENDED_TO_CLIENT_3",
}

export enum ENUM_REFUNDREQUEST_TEMPLATE {
  CERT_NUMBER_ERROR = "CERT_NUMBER_ERROR",
  DEFAULT_REQUEST = "DEFAULT_REQUEST",
  DEFAULT_REQUEST_INS = "DEFAULT_REQUEST_INS",
  NON_RETURN = "NON_RETURN",
  ON_PERSONAL = "ON_PERSONAL",
  PURCHASE_PLACE = "PURCHASE_PLACE",
  SEVEN_DAYS = "SEVEN_DAYS",
  SMS_REQUEST = "SMS_REQUEST",
  WALK_TO_MAIL = "WALK_TO_MAIL",
  WALK_TO_MFO = "WALK_TO_MFO",
  WALK_TO_OFFICE = "WALK_TO_OFFICE",
}

export enum ENUM_REFUNDREQUEST_TYPE {
  free = "free",
  vip = "vip",
}

export interface ActivateInput {
  Certificate_Number?: string | null;
  Certificate_Date?: any | null;
  Device_Type?: string | null;
  Device_Name?: string | null;
  Device_Number?: string | null;
  FIO?: string | null;
  Phone?: string | null;
}

export interface ConsultationInput {
  Certificate_Number?: string | null;
  Certificate_Date?: any | null;
  FIO?: string | null;
  Phone?: string | null;
  status?: ENUM_CONSULTATION_STATUS | null;
}

export interface LossInput {
  FIO?: string | null;
  Phone?: string | null;
  Certificate_Number?: string | null;
  Certificate_Date?: any | null;
  Comment?: string | null;
  Email?: string | null;
}

export interface PartnerInput {
  FIO?: string | null;
  Company?: string | null;
  Phone?: string | null;
  status?: ENUM_PARTNER_STATUS | null;
  INN?: string | null;
  Email?: string | null;
}

export interface RefundRequestInput {
  status?: ENUM_REFUNDREQUEST_STATUS | null;
  requestPdfFileUrl?: string | null;
  requestData?: any | null;
  validationErrorMessage?: string | null;
  template?: ENUM_REFUNDREQUEST_TEMPLATE | null;
  type?: ENUM_REFUNDREQUEST_TYPE | null;
  orderNumber?: string | null;
  orderStatus?: ENUM_REFUNDREQUEST_ORDERSTATUS | null;
  orderLink?: string | null;
  FIO?: string | null;
  Phone?: string | null;
  Email?: string | null;
  orderValue?: number | null;
  application?: boolean | null;
  details?: boolean | null;
  Certificate_Number?: string | null;
  signStatus?: ENUM_REFUNDREQUEST_SIGNSTATUS | null;
  signCode?: string | null;
  signSendStatus?: ENUM_REFUNDREQUEST_SIGNSENDSTATUS | null;
  signDate?: any | null;
}

export interface recordActivateInput {
  code: string;
  email: string;
}

export interface smsActivateInput {
  code: string;
  email: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
